import { render, staticRenderFns } from "./Bec-sucre.vue?vue&type=template&id=e8c23a28&scoped=true&"
import script from "./Bec-sucre.vue?vue&type=script&lang=js&"
export * from "./Bec-sucre.vue?vue&type=script&lang=js&"
import style0 from "./Bec-sucre.vue?vue&type=style&index=0&id=e8c23a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c23a28",
  null
  
)

export default component.exports